import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule, SELECTION_MODEL_FACTORY} from '@ng-select/ng-select';
import {RelatedDocumentComponent} from './related-document.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {ValidationMessageModule} from '../../../../formbird-sc-shared/src/lib/components/validation/validation-message.module';
import { default as pjson } from '../../../../../package.json';
import {
  CustomSelectionModelFactory,
  SelectionModelFactory
} from './ng-select-custom-selection/ng-select-custom-selection-model';

@NgModule({
  declarations: [
    RelatedDocumentComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    NgSelectModule,
    ComponentSetupModule,
    ValidationMessageModule
  ],
  providers: [{ provide: SELECTION_MODEL_FACTORY, useValue: CustomSelectionModelFactory as SelectionModelFactory }]
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class RelatedDocumentV1Module {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(RelatedDocumentComponent, 'sc-related-document-v1', this.injector, pjson.version);
  }
}
